<template>
  <div class="planswitchhistory-page page-wrapper">
    <div class="container-fluid">
      <div class="planswitch_headercontainer d-flex align-items-end justify-content-between flex-wrap gap-2">
        <div class="left-content">
          <breadcrumb :items="breadcrumbItems" />
          <div class="page-title">
            <h1>Plan Switch History</h1>
          </div>
        </div>
      </div>

      <div class="row plan-switch-card">

        <!-- FILTERS -->
        <div class="planswitchhistory-filters">
  <div class="row align-items-end">
    <div class="col-md-4 mb-3 ">
       <!-- Member Name -->
          <div class="filter-input-wrap w-100">
            <input type="text" class="filter-input" placeholder="Enter Member Name" v-model="filters.member_name" />
            <div class="icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"/></svg>
            </div>
          </div>

    </div>
    <div class="col-md-4 mb-3 ">
 <!-- From Plan -->
          <div class="filter-input-wrap">
            <input type="text" class="filter-input" placeholder="Enter Old Plan" v-model="filters.old_plan" />
             <div class="icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"/></svg>
            </div>
          </div>
    </div>
    <div class="col-md-4 mb-3 ">
 <!-- To Plan -->
          <div class="filter-input-wrap">
            <input type="text" class="filter-input" placeholder="Enter New Plan" v-model="filters.new_plan" />
             <div class="icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"/></svg>
            </div>
          </div>
    </div>
    <div class="col-md-4 mb-3 mb-md-0 ">
     
 <!-- Date -->
          <div class="date-range-wrapper">
            <div class="fw-semibold">Date:</div>
            <input type="date" v-model="filters.date" class="date-input" />
          </div>
    </div>
    <div class="col-md-6">
       <div class="d-flex gap-2">
          <!-- Search Button -->
          <button class="search-btn univ-btn py-2 px-3 d-flex align-items-center gap-1 m-0 w-auto" @click="getPlanSwitchLogs">
            <span class="icon-wrap d-flex align-items-center justify-content-center">
               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10a7 7 0 1 0 14 0a7 7 0 1 0-14 0m18 11l-6-6"/></svg>
            </span>
            Search
          </button>

          <!-- Clear Button -->
          <button class="clear-btn d-flex align-items-center gap-1" @click="clearFilters">
            <span class="icon-wrap d-flex align-items-center justify-content-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
                <path fill="currentColor"
                  d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z" />
              </svg>
            </span>
            Clear
          </button>
      </div>
 
    </div>
  </div>
         
         

         

         

       

        </div>

        <!-- TOP PAGINATION -->
        <div class="top-pagination p-0">
          <pagination :rows.sync="rows" :filters="filters" />
        </div>

        <!-- TABLE -->
        <div class="table-responsive p-0">
          <table class="table planswitchhistory-table">
            <thead>
              <tr>
                <th>System ID</th>
                <th>Member Name</th>
                <th>Date & Time</th>
                <th>Old Plan</th>
                <th>New Plan</th>
                <th>Performed by</th>
                <th>Requested From</th>
                <th>Details</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="item in planSwitches" :key="item.id">
                <td>{{ item.policy_id }}</td>

                <td>
                  <div class="fw-semibold">{{ item.member_name }}</div>
                </td>

                <td>{{ formatDate(item.created_at) }}</td>

                <td>{{ item.old_plan_name }}</td>

                <td>{{ item.new_plan_name }}</td>

                <td>
                  <div class="d-flex align-items-center gap-2">
                    <div class="avatar-circle d-flex align-items-center justify-content-center">
                      {{ getInitials(item.requested_by) }}
                    </div>
                    <div>
                      <div class="fw-semibold">{{ item.requested_by }}</div>
                    </div>
                  </div>
                </td>

                <td>{{ item.origin }}</td>

                <td>
                  <button class="view-link" @click.prevent="openViewModal(item)">View</button>
                </td>
              </tr>

              <tr v-if="planSwitches.length === 0">
                <td colspan="8" class="text-center">No plan switch history found</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- BOTTOM PAGINATION -->
        <pagination :rows.sync="rows" :filters="filters" />

      </div>
    </div>

    <PlanSwitchHistoryModal :isOpen="showPlanSwitchHistoryModal" :row="row"
      @close="showPlanSwitchHistoryModal = false" />
  </div>
</template>

<script>
import axios from "axios";
import "./PlanSwitchHistory.css";
import PlanSwitchHistoryModal from "./PlanSwitchHistoryModal.vue";
// import Api from "@/resource/Api";

export default {
  components: {
    PlanSwitchHistoryModal,
  },

  data() {
    return {
      breadcrumbItems: [{ title: "Plan Switch History", active: true }],
      row: null,
      showPlanSwitchHistoryModal: false,
      planSwitches: [],
      rows: [],
      filters: {
        member_name: "",
        old_plan: "",
        new_plan: "",
        date: "",
      },
    };
  },

  watch: {
    rows(newVal) {
      this.planSwitches = newVal.records || [];
    },
  },

  methods: {
    formatDate(isoString) {
      if (!isoString) return '';
      return new Date(isoString).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
    },

    async getPlanSwitchLogs() {
      let loader = this.$loading.show();
      try {
        const params = {
          ...(this.filters.member_name && { member_name: this.filters.member_name }),
          ...(this.filters.old_plan && { old_plan: this.filters.old_plan }),
          ...(this.filters.new_plan && { new_plan: this.filters.new_plan }),
          ...(this.filters.date && { date: this.filters.date }),
        };

        const response = await axios.get('v2/switch-plan-logs', { params });
        this.rows = response.data;
        this.planSwitches = response.data.records;
      } catch (err) {
        this.$notify(err.response.data.message || 'Something went wrong', 'error');
      } finally {
        loader.hide();
      }
    },

    getInitials(name) {
      if (!name) return "";
      return name.split(" ").map(word => word.charAt(0)).join("").toUpperCase();
    },

    clearFilters() {
      this.filters = {
        member_name: "",
        old_plan: "",
        new_plan: "",
        date: "",
      };
      this.getPlanSwitchLogs();
    },

    openViewModal(item) {
      this.row = item;
      this.showPlanSwitchHistoryModal = true;
    },
  },

  mounted() {
    this.getPlanSwitchLogs();
  },
};
</script>

<style scoped></style>